import {Component, OnInit} from '@angular/core';
import {AppConfig} from "../app.config";
import {Auth} from "../app.auth";
import {Router} from "@angular/router";
import {AuthService} from "../auth.service";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {ErrorCode} from "../enums/error-codes";
import {BasicValidators} from "../validators/basic.validators";
import {UserValidators} from "../validators/user.validators";
import {GroupType} from "../enums/group-type.enum";

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})
export class SignInComponent implements OnInit {
    form: FormGroup;
    isLoading: boolean = false;
    errorFromServer: number = 0;

    constructor(private _config: AppConfig,
                private _authService: AuthService,
                private _auth: Auth,
                private _router: Router,
                private _builder: FormBuilder) {
    }

    ngOnInit() {
        this.form = this._builder.group({
            email: [
                '',
                Validators.compose([
                    Validators.required,
                    BasicValidators.invalidEmail
                ])
            ],
            password: [
                '',
                Validators.compose([
                    Validators.required,
                    UserValidators.passwordLength(this._config.getPreferences())
                ])
            ]
        });
    }

    performLogin() {
        this.isLoading = true;

        this._authService
            .signIn(this.form.controls['email'].value, this.form.controls['password'].value)
            .subscribe(
                results => {
                    if (results.error) {
                        this.errorFromServer = results.error;
                    }
                    else if (results.user && results.authorization_token) {
                        if ( results.user.permissions.group_id == GroupType.FullManager ) {
                            this._auth.authToken = results.authorization_token;
                            this._auth.user = results.user;
                            this._router.navigate(["/"]);
                        }
                        else {
                            this.errorFromServer = ErrorCode.NotAuthorized;
                        }
                    }
                },
                null,
                () => this.isLoading = false
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/signin/signin.component.ts